import React, { Component } from 'react'
import Link from 'gatsby-link'
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Col,
  Row,
  Modal,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap'
import Amplify, { API, Auth } from 'aws-amplify'
import {
  getMfaMessageSuffix,
  getMfaTypeLabel,
  isMfaChallenge,
  isMfaTypeSelectionChallenge,
  parseAvailableMfaTypes,
  selectMfaType,
} from '../js/cognitoEmailMfa'
import $ from 'jquery'
import NewLogin from './NewLogin'
import { Provider } from 'react-redux'
import configureMockStore from 'redux-mock-store'
import { USER_TYPES } from '../js/constants'
import { GTM_DATA_LAYER } from '../js/gtm'

const mockStore = configureMockStore()
const store = mockStore({})
const windowGlobal = typeof window !== 'undefined' && window

class Header extends Component {
  constructor(props) {
    super(props)
    let {
      Region,
      IdentityPoolId,
      UserPoolId,
      ClientId,
      EndPoint,
      Account,
      TProEndpoint,
    } = props.APIConfig.COGNITO
    Amplify.configure({
      Auth: {
        identityPoolId: IdentityPoolId,
        region: Region,
        userPoolId: UserPoolId,
        userPoolWebClientId: ClientId,
      },
      API: {
        endpoints: [
          { name: 'rapapi', endpoint: EndPoint.Url, region: Region },
          { name: 'accapi', endpoint: Account.Url, region: Region },
          { name: 'tproapi', endpoint: TProEndpoint.Url, region: Region },
        ],
      },
    })
    this.state = {
      showLoginModal: false,
      showSignUpModal: false,
      showSignUpThankYouModal: false,
      showChangeCognitoPasswordModal: false,
      agencyModal: false,
      activeKey: 1,
      email: '',
      accreditationClia: '',
      accreditationIata: '',
      accreditationTpr: '',
      password: '',
      newInputPassword: '',
      isSigningIn: false,
      isRequestingAccount: false,
      errors: {
        email: '',
        password: '',
        login: '',
        forgotPassword: '',
        newPassword: '',
        mfa: '',
      },
      errorCode: undefined,
      tokenId: null,
      store: null,
      isEmailTouched: false,
      isRequestEmailTouched: false,
      isPasswordTouched: false,
      isIATATouched: false,
      isTPRTouched: false,
      isCLIATouched: false,
      isValidPassword: false,
      isValidEmail: false,
      isValidNewPassword: false,
      forgotPassword: false,
      newPassword: false,
      code: '',
      hasRegistered: false,
      // MFA additions
      mfaRequired: false,
      mfaTypeSelectionRequired: false,
      availableMfaTypes: [],
      mfaCode: '',
      challengeUser: null,
    }

    this.login = this.login.bind(this)
    this.handleMfaSubmit = this.handleMfaSubmit.bind(this)
    this.handleMfaTypeSelect = this.handleMfaTypeSelect.bind(this)
    this.userRegistration = this.userRegistration.bind(this)
    this.passwordUpdated = this.passwordUpdated.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.validateField = this.validateField.bind(this)
    this.handleForgotPassword = this.handleForgotPassword.bind(this)
    this.submitNewPassword = this.submitNewPassword.bind(this)
    this.handleSubmitPassword = this.handleSubmitPassword.bind(this)
    this.showForgotPassword = this.showForgotPassword.bind(this)

    this.showLogin = () => {
      this.setState({
        showLoginModal: !this.state.showLoginModal,
        showChangeCognitoPasswordModal: false,
        mfaRequired: false,
        mfaTypeSelectionRequired: false,
        availableMfaTypes: [],
        mfaCode: '',
      })
    }

    this.showSignUp = () => {
      GTM_DATA_LAYER.push({ event: 'register', eventType: 'showRegisterForm' })
      this.setState({
        showSignUpModal: !this.state.showSignUpModal,
        agencyModal: false,
      })
    }

    this.showSignUpThankYou = () => {
      GTM_DATA_LAYER.push({
        event: 'register',
        eventType: 'showRegisterThankYou',
      })
      this.setState({
        showSignUpThankYouModal: !this.state.showSignUpThankYouModal,
        showSignUpModal: false,
      })
    }

    this.showChangeCognitoPassword = () => {
      GTM_DATA_LAYER.push({
        event: 'changePassword',
        eventType: 'showChangeCognitoPassword',
      })
      this.setState({
        showLoginModal: false,
        showChangeCognitoPasswordModal: !this.state
          .showChangeCognitoPasswordModal,
      })
    }

    this.scrollToBottom = (location, e) => {
      this.setState({ activeKey: e })
      $('html,body').animate({ scrollTop: $(location).offset().top }, 'fast')
      if (location === '#home') {
        $('.home-link').addClass('active-home-link')
      } else {
        $('.home-link').removeClass('active-home-link')
      }
    }

    this.resetFormState = () => {
      this.setState({
        email: '',
        password: '',
        accreditationClia: '',
        accreditationIata: '',
        accreditationTpr: '',
        errors: {
          email: '',
          password: '',
          login: '',
          forgotPassword: '',
          newPassword: '',
          mfa: '',
        },
        errorCode: undefined,
        mfaRequired: false,
        mfaTypeSelectionRequired: false,
        availableMfaTypes: [],
        mfaCode: '',
      })
    }
  }

  componentDidMount() {
    Auth.currentAuthenticatedUser()
      .then(user => {
        if (
          !(
            window.location.pathname.indexOf('covid') !== -1 ||
            window.location.pathname.indexOf('faq') !== -1 ||
            window.location.pathname.indexOf('privacy') !== -1 ||
            window.location.pathname.indexOf('terms') !== -1
          )
        ) {
          window.location = window.location.origin + '/#/search'
        }
      })
      .catch(e => {
        let tokenId = this.getParameterByName('token_id')
        if (tokenId) {
          this.setState({ tokenId })
          this.showLogin()
        }
        let register = this.getParameterByName('register')
        if (register) {
          this.showSignUp()
        }
        const signUpButton = document.querySelector('.sign-up')
        if (signUpButton) {
          signUpButton.addEventListener('click', event => {
            this.showSignUp()
          })
        }
      })
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  async handleMfaTypeSelect(mfaType) {
    this.setState({
      isSigningIn: true,
      errors: { ...this.state.errors, mfa: '' },
    })

    try {
      const user = await selectMfaType(this.state.challengeUser, mfaType)
      this.setState({
        mfaTypeSelectionRequired: false,
        mfaRequired: true,
        challengeUser: user,
        mfaCode: '',
        isSigningIn: false,
      })
    } catch (err) {
      this.setState({
        isSigningIn: false,
        errors: {
          ...this.state.errors,
          mfa: err.message || 'Failed to send verification code',
        },
      })
    }
  }

  async handleMfaSubmit(e) {
    if (e) e.preventDefault()
    this.setState({
      isSigningIn: true,
      errors: { ...this.state.errors, mfa: '' },
    })
    try {
      await Auth.confirmSignIn(
        this.state.challengeUser,
        this.state.mfaCode,
        this.state.challengeUser.challengeName
      )
      this.checkUserAuthorization()
    } catch (err) {
      this.setState({
        isSigningIn: false,
        errors: {
          ...this.state.errors,
          mfa: err.message || 'Invalid MFA code',
        },
      })
    }
  }

  getAuthorizedTravelProOrgs(currentUser) {
    const orgRoles = currentUser && currentUser.organization_roles
    if (!Array.isArray(orgRoles)) {
      return []
    }

    return orgRoles.filter(org => {
      const roles = org && org.roles
      if (!Array.isArray(roles)) {
        return false
      }

      return Object.keys(USER_TYPES).some(type => {
        return roles.indexOf(USER_TYPES[type]) > -1
      })
    })
  }

  async checkUserAuthorization() {
    try {
      let currentUser = await API.get('accapi', '/currentuser', {})
      if (!currentUser) {
        this.failed({
          message: 'Unable to verify your account. Please try signing in again.',
        })
        return
      }

      GTM_DATA_LAYER.push({ event: 'logIn', eventType: 'getCurrentUser' })
      let tproOrgs = this.getAuthorizedTravelProOrgs(currentUser)

      if (!tproOrgs.length) {
        try {
          await Auth.signOut()
        } catch (signOutError) {
          // Show unauthorized message even if sign-out fails.
        }
        this.failed({
          message: 'This user is not authorized with RedAwning TravelPro',
        })
        return
      }

      window.location = window.location.origin + '/#/search'
    } catch (e) {
      this.failed(e)
    }
  }

  async login(confirmPassword) {
    var vm = this
    vm.setState({
      isSigningIn: true,
      errors: { ...this.state.errors, login: undefined, mfa: '' },
      errorCode: undefined,
    })
    try {
      let email = this.state.email.toLowerCase()
      let password = confirmPassword || this.state.password
      let user = await Auth.signIn(email, password)

      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        GTM_DATA_LAYER.push({
          event: 'logIn',
          eventType: 'newPasswordRequired',
        })
        this.setState({ user, isSigningIn: false })
        this.showChangeCognitoPassword()
      } else if (user && isMfaTypeSelectionChallenge(user.challengeName)) {
        this.setState({
          mfaTypeSelectionRequired: true,
          availableMfaTypes: parseAvailableMfaTypes(user.challengeParam),
          challengeUser: user,
          isSigningIn: false,
        })
      } else if (user && isMfaChallenge(user.challengeName)) {
        this.setState({
          mfaRequired: true,
          mfaTypeSelectionRequired: false,
          challengeUser: user,
          isSigningIn: false,
        })
      } else {
        this.checkUserAuthorization()
      }
    } catch (err) {
      this.failed(err)
    }
  }

  async userRegistration(confirmPassword) {
    if (this.state.tokenId && confirmPassword) {
      try {
        let regTokenPath = `/registration/${this.state.tokenId}`
        this.setState({ isSigningIn: true, hasRegistered: true })
        GTM_DATA_LAYER.push({
          event: 'changePassword',
          eventType: 'registerUser',
        })
        await API.post('tproapi', regTokenPath, { body: {} })
        this.login(confirmPassword)
      } catch (e) {
        this.setState({ isSigningIn: false })
        this.failed({ message: 'Invalid TokenID' })
      }
    } else {
      this.failed({
        message:
          'Please follow the link sent in your email to finish the registration process',
      })
    }
  }

  async handleForgotPassword(e) {
    e.preventDefault()
    this.setState({
      errors: {
        email: '',
        password: '',
        login: '',
        forgotPassword: '',
        newPassword: '',
        mfa: '',
      },
    })
    try {
      let sent = await Auth.forgotPassword(this.state.email)
      if (sent) {
        this.setState({ newPassword: true, password: '', newInputPassword: '' })
      }
    } catch (err) {
      this.setState({
        errors: { ...this.state.errors, forgotPassword: err.message },
        errorCode: err.code,
      })
    }
  }

  async submitNewPassword() {
    GTM_DATA_LAYER.push({
      event: 'changePassword',
      eventType: 'submitNewPassword',
    })
    try {
      await Auth.forgotPasswordSubmit(
        this.state.email,
        this.state.code,
        this.state.newInputPassword
      )
      this.setState({ forgotPassword: false, showLoginModal: true })
    } catch (err) {
      this.setState({
        errors: { ...this.state.errors, newPassword: err.message },
      })
    }
  }

  handleSubmitPassword(e) {
    e.preventDefault()
    this.setState({
      errors: {
        email: '',
        password: '',
        login: '',
        forgotPassword: '',
        newPassword: '',
        mfa: '',
      },
    })
    this.submitNewPassword()
  }

  showForgotPassword() {
    GTM_DATA_LAYER.push({
      event: 'changePassword',
      eventType: 'showForgotPassword',
    })
    // Fix for the "dark background" issue: explicitly close login first
    this.setState({
      showLoginModal: false,
      forgotPassword: true,
      newPassword: false,
    })
  }

  passwordUpdated(confirmPassword) {
    if (this.state.tokenId && this.state.email && confirmPassword) {
      GTM_DATA_LAYER.push({
        event: 'changePassword',
        eventType: 'passwordUpdated',
      })
      this.userRegistration(confirmPassword)
    } else {
      this.setState({
        user: null,
        isSigningIn: false,
        password: '',
        showChangeCognitoPasswordModal: false,
      })
    }
  }

  async userRequestAccount() {
    GTM_DATA_LAYER.push({
      event: 'register',
      eventType: 'userRequestAccount',
    })
    this.setState({ isSigningIn: true })
    let payload = {
      body: {},
    }
    if (
      this.state.email &&
      (this.state.accreditationIata ||
        this.state.accreditationClia ||
        this.state.accreditationTpr)
    ) {
      payload.body.email = this.state.email
      payload.body.accreditation_iata = this.state.accreditationIata
      payload.body.accreditation_clia = this.state.accreditationClia
      payload.body.accreditation_tpr = this.state.accreditationTpr

      try {
        await API.post('tproapi', '/viewerusers', payload)
        this.showSignUpThankYou()
      } catch (e) {
        //console.log('userRequestAccount Error:', e);
        this.failed({ message: 'Invalid request' })
      }
    }
    this.setState({ isSigningIn: false })
  }

  failed(err) {
    this.setState({
      isSigningIn: false,
      isRequestingAccount: false,
      mfaRequired: false,
      mfaTypeSelectionRequired: false,
      availableMfaTypes: [],
      mfaCode: '',
      challengeUser: null,
      errors: { ...this.state.errors, login: err.message, mfa: '' },
      errorCode: err.code,
    })
  }

  validateField(name, value) {
    let validationErrors = this.state.errors
    let passwordValid = this.state.isValidPassword
    let emailValid = this.state.isValidEmail
    let newPasswordValid = this.state.isValidNewPassword
    let regExp = ''
    switch (name) {
      case 'email':
        regExp = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
        emailValid = regExp.test(value)
        validationErrors.email = emailValid
          ? ''
          : 'Invalid email. Please input a valid email address.'
        break
      case 'password':
        passwordValid = value !== ''
        break
      case 'newInputPassword':
        regExp = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,16}$/
        newPasswordValid = regExp.test(value)
        validationErrors.newPassword = newPasswordValid
          ? ''
          : 'Password must contain at least one lowercase, uppercase, numeric, and special character (8-16 chars).'
        break
    }
    this.setState({
      errors: validationErrors,
      isValidEmail: emailValid,
      isValidPassword: passwordValid,
      isValidNewPassword: newPasswordValid,
    })
  }

  handleChange(e) {
    const { name, value } = e.target
    this.setState({ [name]: value }, () => this.validateField(name, value))
  }

  clickLogin() {
    this.login()
  }

  clickRequestAccount() {
    this.userRequestAccount()
  }

  getValidationState(fieldName) {
    switch (fieldName) {
      case 'email':
      case 'password':
        if (this.state.errors[fieldName].length === 0) {
          return null
        } else {
          return 'error'
        }
      default:
        if (this.state[fieldName] !== '') {
          return null
        } else {
          return 'error'
        }
    }
  }

  requestAgencyAccount() {
    this.setState({
      agencyModal: true,
    })
  }

  render() {
    var challengeUser = this.state.challengeUser
    var challengeName = (challengeUser && challengeUser.challengeName) || ''
    var messageSuffix = getMfaMessageSuffix(challengeName)

    return (
      <div className="main-header" id="home">
        <Navbar fluid fixedTop collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>
              <Link className="no-margin" id="brand" to="/home">
                <img src="/app/assets/icons/redawning_travelpro_logo.svg" />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight activeKey={this.state.activeKey}>
              {windowGlobal &&
              windowGlobal.location &&
              !(
                window.location.pathname.indexOf('covid') !== -1 ||
                windowGlobal.location.pathname.indexOf('faq') !== -1 ||
                windowGlobal.location.pathname.indexOf('privacy') !== -1 ||
                windowGlobal.location.pathname.indexOf('terms') !== -1
              ) ? (
                <NavItem
                  className="text-16"
                  href="#jump2"
                  eventKey={2}
                  onClick={() => this.scrollToBottom('#jump2', 2)}
                >
                  {window &&
                    window.document &&
                    window.document.getElementsByClassName('jump2-title') &&
                    window.document.getElementsByClassName('jump2-title')[0] &&
                    window.document.getElementsByClassName('jump2-title')[0]
                      .textContent}
                </NavItem>
              ) : null}
              {windowGlobal &&
              windowGlobal.location &&
              !(
                window.location.pathname.indexOf('covid') !== -1 ||
                windowGlobal.location.pathname.indexOf('faq') !== -1 ||
                windowGlobal.location.pathname.indexOf('privacy') !== -1 ||
                windowGlobal.location.pathname.indexOf('terms') !== -1
              ) ? (
                <NavItem
                  className="text-16"
                  href="#jump3"
                  eventKey={3}
                  onClick={() => this.scrollToBottom('#jump3', 3)}
                >
                  {window &&
                    window.document &&
                    window.document.getElementsByClassName('jump3-title') &&
                    window.document.getElementsByClassName('jump3-title')[0] &&
                    window.document.getElementsByClassName('jump3-title')[0]
                      .textContent}
                </NavItem>
              ) : null}
              {windowGlobal &&
              windowGlobal.location &&
              !(
                window.location.pathname.indexOf('covid') !== -1 ||
                windowGlobal.location.pathname.indexOf('faq') !== -1 ||
                windowGlobal.location.pathname.indexOf('privacy') !== -1 ||
                windowGlobal.location.pathname.indexOf('terms') !== -1
              ) ? (
                <NavItem
                  className="text-16"
                  href="#jump5"
                  eventKey={5}
                  onClick={() => this.scrollToBottom('#jump5', 5)}
                >
                  {window &&
                    window.document &&
                    window.document.getElementsByClassName('jump5-title') &&
                    window.document.getElementsByClassName('jump5-title')[0] &&
                    window.document.getElementsByClassName('jump5-title')[0]
                      .textContent}
                </NavItem>
              ) : null}
              {windowGlobal &&
              windowGlobal.location &&
              (window.location.pathname.indexOf('covid') !== -1 ||
                windowGlobal.location.pathname.indexOf('faq') !== -1 ||
                windowGlobal.location.pathname.indexOf('privacy') !== -1 ||
                windowGlobal.location.pathname.indexOf('terms') !== -1) ? (
                <NavItem className="text-16" href="/home">
                  Home
                </NavItem>
              ) : null}
              {windowGlobal && windowGlobal.location ? (
                <NavItem className="text-16" href="/faq">
                  FAQs
                </NavItem>
              ) : null}
              {windowGlobal &&
              windowGlobal.location &&
              !(
                window.location.pathname.indexOf('covid') !== -1 ||
                windowGlobal.location.pathname.indexOf('faq') !== -1 ||
                windowGlobal.location.pathname.indexOf('privacy') !== -1 ||
                windowGlobal.location.pathname.indexOf('terms') !== -1
              ) ? (
                <NavItem
                  className="text-16 nav-btn nav-btn-red"
                  onClick={() => {
                    this.showLogin()
                    this.resetFormState()
                  }}
                >
                  Sign In
                </NavItem>
              ) : null}
              {windowGlobal &&
              windowGlobal.location &&
              !(
                window.location.pathname.indexOf('covid') !== -1 ||
                windowGlobal.location.pathname.indexOf('faq') !== -1 ||
                windowGlobal.location.pathname.indexOf('privacy') !== -1 ||
                windowGlobal.location.pathname.indexOf('terms') !== -1
              ) ? (
                <NavItem
                  className="text-16 nav-btn nav-btn-blue"
                  onClick={() => {
                    this.showSignUp()
                    this.resetFormState()
                  }}
                >
                  Request an Account
                </NavItem>
              ) : null}
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        {/* Thank You Modal */}
        <Modal
          className="sign-up-thank-you-modal"
          show={this.state.showSignUpThankYouModal}
          onHide={() => this.setState({ showSignUpThankYouModal: false })}
        >
          <Modal.Header className="custom-modal-header" closeButton>
            <Modal.Title />
          </Modal.Header>
          <Modal.Body>
            <Grid fluid={true}>
              <Row>
                <Col xs={12}>
                  <h2 className="modal-heading">Thank you!</h2>
                  <h3>
                    Your new account is being processed. Please check your email
                    for further instructions.
                  </h3>
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
        </Modal>

        {/* Change Password / New Password Required Modal */}
        <Modal
          backdrop={'static'}
          className="sign-up-new-login"
          show={this.state.showChangeCognitoPasswordModal}
        >
          <Modal.Body>
            <Provider store={store}>
              <NewLogin
                user={this.state.user}
                onPasswordUpdate={this.passwordUpdated}
                processing={this.state.isSigningIn}
              />
            </Provider>
          </Modal.Body>
        </Modal>

        {/* Sign Up Modal (Iframe) */}
        <Modal
          className="sign-up-modal"
          show={this.state.showSignUpModal}
          onHide={() => this.setState({ showSignUpModal: false })}
        >
          <Modal.Header className="custom-modal-header" closeButton>
            <Modal.Title />
          </Modal.Header>
          <Modal.Body>
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSeexW_MgOAnWFgQlHIpKhNMTNy5xyYnbmpYnq7MEBHzUslMkA/viewform"
              width="100%"
              height="640"
              frameBorder="0"
            >
              Loading...
            </iframe>
          </Modal.Body>
        </Modal>

        {/* Main Login / MFA Modal */}
        <Modal
          className="log-in-modal"
          show={this.state.showLoginModal}
          onHide={() => this.setState({ showLoginModal: false })}
        >
          <Modal.Header className="custom-modal-header" closeButton>
            <Modal.Title />
          </Modal.Header>
          <Modal.Body>
            <Grid fluid={true}>
              <Row>
                <Col xs={12}>
                  <h2 className="modal-heading">
                    {this.state.mfaTypeSelectionRequired
                      ? 'Choose Verification Method'
                      : this.state.mfaRequired
                        ? 'Security Verification'
                        : 'Login'}
                  </h2>
                </Col>
              </Row>
              {this.state.mfaTypeSelectionRequired ? (
                <Row>
                  <Col xs={12}>
                    <p>
                      Choose how you would like to receive your verification
                      code.
                    </p>
                    {this.state.availableMfaTypes.map(mfaType => (
                      <Button
                        key={mfaType}
                        className="login-btn cursor-pointer"
                        disabled={this.state.isSigningIn}
                        onClick={() => this.handleMfaTypeSelect(mfaType)}
                        block
                        style={{ marginBottom: '10px' }}
                      >
                        Send code via {getMfaTypeLabel(mfaType)}
                      </Button>
                    ))}
                    {this.state.errors.mfa && (
                      <HelpBlock className="error-text">
                        {this.state.errors.mfa}
                      </HelpBlock>
                    )}
                  </Col>
                </Row>
              ) : !this.state.mfaRequired ? (
                <Row>
                  <Col sm={12}>
                    <FormGroup
                      controlId="loginusernameinput"
                      validationState={
                        this.state.isEmailTouched &&
                        this.state.errors.email.length > 0
                          ? 'error'
                          : null
                      }
                    >
                      <ControlLabel>Username</ControlLabel>
                      <FormControl
                        type="text"
                        name="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        onBlur={() => this.setState({ isEmailTouched: true })}
                        required
                      />
                    </FormGroup>
                    {this.state.errors.email && (
                      <HelpBlock className="error-text">
                        {this.state.errors.email}
                      </HelpBlock>
                    )}
                  </Col>
                  <Col sm={12}>
                    <FormGroup controlId="loginpasswordinput">
                      <ControlLabel>Password</ControlLabel>
                      <FormControl
                        type="password"
                        name="password"
                        value={this.state.password}
                        onChange={this.handleChange}
                        required
                        onKeyDown={e =>
                          e.keyCode === 13 &&
                          this.state.isValidEmail &&
                          this.state.isValidPassword
                            ? this.clickLogin()
                            : null
                        }
                      />
                    </FormGroup>
                    {this.state.errors.login && (
                      <HelpBlock className="error-text">
                        {this.state.errors.login}
                      </HelpBlock>
                    )}
                  </Col>
                  <Col xs={12}>
                    <a
                      href="javascript:void(0)"
                      className="float-right"
                      onClick={this.showForgotPassword}
                    >
                      Forgot Password
                    </a>
                  </Col>
                  <Col xs={12} className="button-container">
                    <Button
                      className={
                        !this.state.isValidEmail || !this.state.isValidPassword
                          ? 'default-btn'
                          : 'login-btn cursor-pointer'
                      }
                      disabled={
                        !this.state.isValidEmail ||
                        !this.state.isValidPassword ||
                        this.state.isSigningIn
                      }
                      onClick={() => this.clickLogin()}
                    >
                      Sign In{' '}
                      <i
                        className={
                          'glyphicon glyphicon-refresh ' +
                          (this.state.isSigningIn ? ' spinning' : ' hide')
                        }
                      />
                    </Button>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col xs={12}>
                    <p>Please enter the verification code{messageSuffix}</p>
                    <FormGroup controlId="mfacodeinput">
                      <ControlLabel>Code</ControlLabel>
                      <FormControl
                        type="text"
                        name="mfaCode"
                        value={this.state.mfaCode}
                        onChange={this.handleChange}
                        autoFocus
                        onKeyDown={e =>
                          e.keyCode === 13 && this.state.mfaCode
                            ? this.handleMfaSubmit()
                            : null
                        }
                      />
                    </FormGroup>
                    {this.state.errors.mfa && (
                      <HelpBlock className="error-text">
                        {this.state.errors.mfa}
                      </HelpBlock>
                    )}
                    <Button
                      className="login-btn cursor-pointer"
                      disabled={!this.state.mfaCode || this.state.isSigningIn}
                      onClick={() => this.handleMfaSubmit()}
                    >
                      Verify & Login{' '}
                      <i
                        className={
                          'glyphicon glyphicon-refresh ' +
                          (this.state.isSigningIn ? ' spinning' : ' hide')
                        }
                      />
                    </Button>
                  </Col>
                </Row>
              )}
            </Grid>
          </Modal.Body>
        </Modal>

        {/* Forgot Password Modal */}
        <Modal
          show={this.state.forgotPassword}
          onHide={() => this.setState({ forgotPassword: false })}
        >
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col xs={12}>
                  <h2 className="modal-heading">Forgot Password</h2>
                  {this.state.newPassword && (
                    <p>
                      You will receive an email or text message with a
                      verification code. Please enter that verification code
                      below to continue.
                    </p>
                  )}
                </Col>
              </Row>
              <Row className="page-container form-wrap">
                <Form
                  onSubmit={
                    this.state.newPassword
                      ? this.handleSubmitPassword
                      : this.handleForgotPassword
                  }
                >
                  <Col xs={12}>
                    <FormGroup
                      controlId="formHorizontalEmail"
                      validationState={
                        this.state.errors.email.length > 0 ? 'error' : null
                      }
                    >
                      <FormControl
                        type="text"
                        name="email"
                        placeholder="Email"
                        onChange={this.handleChange}
                        value={this.state.email}
                      />
                    </FormGroup>
                    {this.state.errors.email && (
                      <HelpBlock className="error-text">
                        {this.state.errors.email}
                      </HelpBlock>
                    )}
                    {this.state.errorCode &&
                      this.state.errors.forgotPassword && (
                        <HelpBlock className="error-text">
                          Unable to reset password. Please contact support:
                          travelpro@redawning.com
                        </HelpBlock>
                      )}
                  </Col>
                  {this.state.newPassword && (
                    <Col xs={12}>
                      <FormGroup>
                        <FormControl
                          type="text"
                          name="code"
                          placeholder="Verification Code"
                          value={this.state.code}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                      <FormGroup
                        validationState={
                          this.state.errors.newPassword.length > 0
                            ? 'error'
                            : null
                        }
                      >
                        <FormControl
                          type="password"
                          name="newInputPassword"
                          placeholder="New Password"
                          value={this.state.newInputPassword}
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                      {this.state.errors.newPassword && (
                        <HelpBlock className="error-text">
                          {this.state.errors.newPassword}
                        </HelpBlock>
                      )}
                    </Col>
                  )}
                  <Col xs={12}>
                    <Button
                      type="submit"
                      className={
                        !this.state.isValidEmail ||
                        (this.state.newPassword &&
                          !this.state.isValidNewPassword)
                          ? 'default-btn'
                          : 'login-btn cursor-pointer'
                      }
                      disabled={
                        !this.state.isValidEmail ||
                        (this.state.newPassword &&
                          !this.state.isValidNewPassword) ||
                        this.state.isSigningIn
                      }
                    >
                      {this.state.newPassword
                        ? 'Save Password'
                        : 'Send Reset Code'}{' '}
                      <span
                        className={
                          'glyphicon glyphicon-refresh' +
                          (this.state.isSigningIn ? ' spinning' : ' hide')
                        }
                      />
                    </Button>
                  </Col>
                </Form>
              </Row>
            </Grid>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default Header
